import config from '@/config';

export function getAudienceConfig() {
    // Default configuration for embedded usage (current Laravel app)
    const defaultConfig = {
        apiBaseUrl: config.interactive_url,
        authToken: null,
        pusher: {
            key: 'pezsxnz54a35jjhc',
            cluster: 'eu',
            wsHost: 'broadcaster.documedias.systems',
            wsPort: 443,
            forceTLS: true
        }
    }

    // Merge with global configuration if available (for external usage)
    const globalConfig = window.AUDIENCE_CONFIG || {}
    
    return {
        ...defaultConfig,
        ...globalConfig,
        pusher: {
            ...defaultConfig.pusher,
            ...globalConfig.pusher
        }
    }
}

export function validateConfig(config) {
    const errors = []

    if (config.pusher && !config.pusher.key) {
        errors.push('Pusher key is required for WebSocket functionality')
    }

    if (config.apiBaseUrl && !config.apiBaseUrl.startsWith('http')) {
        errors.push('API base URL must be a complete URL (including protocol) for external usage')
    }

    return {
        isValid: errors.length === 0,
        errors
    }
}